import { render, staticRenderFns } from "./ex2.vue?vue&type=template&id=0a9be7d0&"
import script from "./ex2.vue?vue&type=script&lang=js&"
export * from "./ex2.vue?vue&type=script&lang=js&"
import style0 from "./ex2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ex2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9be7d0')) {
      api.createRecord('0a9be7d0', component.options)
    } else {
      api.reload('0a9be7d0', component.options)
    }
    module.hot.accept("./ex2.vue?vue&type=template&id=0a9be7d0&", function () {
      api.rerender('0a9be7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/gdApply/ex2.vue"
export default component.exports